import { notification } from "socket";

export const Login = ({ name, room }) => {
  notification.emit("login", { name, room }, (err) => {
    if (err) {
      return false;
    } else {
      return true;
    }
  });
};

export const getSingleNotification = () => {
  notification.on("message", function (data) {
    return data;
  });
};

export const getNotifications = () => {
  notification.on("historical_messages", function (messages) {
    return messages;
  });
};

export const sendNotification = ({ message, room, username }) => {
  const chat = {
    message: message,
    room: room,
    username: username,
    timestamp: new Date(),
  };
  notification.emit("message", chat);
};
